import { ChangeDetectionStrategy, Component, Inject, OnInit, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { AuthStoreService } from '../../../core/auth/auth-store.service';
import { BreakpointObserver } from '@angular/cdk/layout';
import { ENVIRONMENT } from '../../../core/models/environment.token';
import { EnvironmentInterface } from '../../../core/models/environment.interface';
import { OneSnackBarService } from '@one/angular-kit/modal';
import { OpenLinkWithReferrerService } from '../../../core/auth/open-link-with-referrer.service';
import { Router } from '@angular/router';

@Component({
  selector: 'dl-double-global-area',
  templateUrl: './double-global-area.component.html',
  styleUrls: ['./double-global-area.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class DoubleGlobalAreaComponent implements OnInit {
  
  public constructor(
    @Inject(ENVIRONMENT) 
    private environment: EnvironmentInterface, 
    private router: Router, 
    private breakpointObserver: BreakpointObserver, 
    private authStoreService: AuthStoreService, 
    private oneSnackBarService: OneSnackBarService, 
    private changeDetectorRef: ChangeDetectorRef, 
    private openLinkWithReferrerService: OpenLinkWithReferrerService
  ) {}

  public profileData: any;
  public userInitials: string;
  public expandUserProfile = false;
  public activeTab: string = window.location.href.slice(window.location.href.lastIndexOf('/')+1);

  public ngOnInit(): void {
    this.profileData = this.authStoreService.userProfile;
    this.userInitials = this.profileData.givenName.substring(0, 1);
  }
  
  public toNotification():void {
    this.activeTab = 'notification';
    this.router.navigateByUrl('/notification');
  }

  public toDashboard():void {
    this.activeTab = 'dashboard';
    this.router.navigateByUrl('/dashboard');
  }

  public toEmailDelivery():void {
    this.activeTab = 'email-delivery';
    this.router.navigateByUrl('/email-delivery');
  }

  // public reDirectHome(availableLocale?: object): string {
  //   let currentPath = window.location.href;
  //   let trimPath =  currentPath.slice(0, currentPath.lastIndexOf('/'));

  //   return trimPath +'/app-enabler';
  // }

  public logout() {
    this.authStoreService.signOut().then( _ =>window.location.href = `${window.location.origin}/logout`);
  }
}
